import { each, find, floor, orderBy, remove, sumBy, toNumber, values } from 'lodash';
import { CouponTypeEnum, DiscountTypeEnum, OffTypeEnum, ProductRelationEnum, StatusEnum, UseLimitTypeEnum, UsePromoCodeStatusEnum, } from '../enum';
import { findActivityProduct, toFixed } from '../lib/utils';
import todayUsedCntMap from '../variable/todayUsedCntMap';
/**
 * 阶梯满减活动
 * @param opt
 * @returns
 */
export default function calLadderDiscount(opt) {
    const { itemMap, enablePromoCodeActivity, ladderItems, isSelectLadderCoupon, memberCouponMap, selectCouponIds, ladderCoupons, 
    // joinLadderCouponIds,
    memberItemCouponMap, isSelectItemCoupon, isSelectCoupon, couponsConfigMap, fullItemNFreeMap, } = opt;
    const effectLadderCouponIds = [];
    let { productAllOff, usePromoCodeStatus, ladderDiscountActivitys, joinLadderCoupons } = opt;
    if (isSelectLadderCoupon) {
        ladderDiscountActivitys = orderBy(ladderDiscountActivitys, ['isIncludeModifier', 'averageDiscountValue', 'extra.isOverlySingleItemDiscount'], ['desc', 'asc', 'desc']);
        if (selectCouponIds && (selectCouponIds === null || selectCouponIds === void 0 ? void 0 : selectCouponIds.length) > 0) {
            joinLadderCoupons = orderBy(joinLadderCoupons, (ladderCoupon) => {
                return selectCouponIds.indexOf(ladderCoupon.memberCouponId);
            }, ['desc']);
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        ladderDiscountActivitys.unshift(...joinLadderCoupons);
    }
    else if (!isSelectCoupon) {
        if (joinLadderCoupons.length <= 0 && ladderCoupons.length > 0) {
            each(ladderCoupons, (ladderCoupon) => {
                if (ladderCoupon.canUse && ladderCoupon.status !== StatusEnum.Disable) {
                    joinLadderCoupons.push(ladderCoupon);
                }
            });
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        ladderDiscountActivitys.push(...joinLadderCoupons);
        ladderDiscountActivitys = orderBy(ladderDiscountActivitys, ['isIncludeModifier', 'averageDiscountValue', 'extra.isOverlySingleItemDiscount'], ['desc', 'asc', 'desc']);
    }
    else {
        ladderDiscountActivitys = orderBy(ladderDiscountActivitys, ['isIncludeModifier', 'averageDiscountValue', 'extra.isOverlySingleItemDiscount'], ['desc', 'asc', 'desc']);
    }
    const disbaleLadderCouponIds = [];
    if (ladderCoupons && ladderCoupons.length > 0) {
        each(ladderCoupons, (ladderCoupon) => {
            var _a, _b;
            if (ladderCoupon.canUse && ladderCoupon.status !== StatusEnum.Disable) {
                // if (isSelectLadderCoupon && !joinLadderCouponIds.includes(ladderCoupon.memberCouponId)) {
                //   return true;
                // }
                // 能参加的活动餐品
                let canJoinProductCnt = 0;
                if (ladderCoupon.productRelation !== ProductRelationEnum.All) {
                    each(ladderItems, (product) => {
                        const findProduct = findActivityProduct(couponsConfigMap[ladderCoupon.couponId].productMap, product);
                        if (findProduct && ladderCoupon.productRelation === ProductRelationEnum.Included) {
                            canJoinProductCnt += product.cnt || 0;
                        }
                        else if (!findProduct && ladderCoupon.productRelation === ProductRelationEnum.Excluded) {
                            canJoinProductCnt += product.cnt || 0;
                        }
                    });
                }
                else {
                    canJoinProductCnt = sumBy(ladderItems, 'cnt');
                }
                const miniLen = ((_b = find((_a = couponsConfigMap[ladderCoupon.couponId].extra) === null || _a === void 0 ? void 0 : _a.ladderDiscount, (ladderCoupon) => {
                    if (ladderCoupon.discountType === DiscountTypeEnum.DiscountRate) {
                        return ladderCoupon.enable && toNumber(ladderCoupon.discountValue) !== 1;
                    }
                    else if (ladderCoupon.discountType === DiscountTypeEnum.DiscountFee) {
                        return ladderCoupon.enable && toNumber(ladderCoupon.discountValue) > 0;
                    }
                    return ladderCoupon.enable;
                })) === null || _b === void 0 ? void 0 : _b.index) || 0;
                if (canJoinProductCnt < miniLen) {
                    ladderCoupon.isSelect = false;
                    ladderCoupon.status = StatusEnum.Disable;
                    ladderCoupon.canUse = false;
                    disbaleLadderCouponIds.push(ladderCoupon.memberCouponId);
                }
            }
        });
    }
    let ladderDiscountAllOff = 0;
    const alearedJoinItemPks = [];
    if (ladderDiscountActivitys.length > 0 && ladderItems.length > 0) {
        const joinPks = [];
        // 遍历活动,判断每个活动是否满足
        each(ladderDiscountActivitys, (activity) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (activity.couponId) {
                if (activity.useLimitType === UseLimitTypeEnum.EveryOrder ||
                    activity.useLimitType === UseLimitTypeEnum.EveryDay) {
                    if (todayUsedCntMap.get(activity.couponId) >= ((activity === null || activity === void 0 ? void 0 : activity.useLimitCnt) || 1)) {
                        activity.isSelect = false;
                        activity.status = StatusEnum.Disable;
                        activity.canUse = false;
                        disbaleLadderCouponIds.push(activity.memberCouponId);
                        return true;
                    }
                    else {
                        todayUsedCntMap.increase(activity.couponId);
                    }
                }
                activity.extra = couponsConfigMap[activity.couponId].extra;
                activity.productMap = couponsConfigMap[activity.couponId].productMap;
            }
            let isCloseOfferCycle = ((_a = activity.extra) === null || _a === void 0 ? void 0 : _a.isCloseOfferCycle) || false;
            if (activity.promoCode && usePromoCodeStatus === UsePromoCodeStatusEnum.Unused) {
                usePromoCodeStatus = UsePromoCodeStatusEnum.Ineffective;
            }
            // 能参加的活动餐品
            let canJoinProducts = [];
            if (activity.productRelation !== ProductRelationEnum.All) {
                each(ladderItems, (product) => {
                    if (!alearedJoinItemPks.includes((product === null || product === void 0 ? void 0 : product.pk) || '')) {
                        const findProduct = findActivityProduct(activity.productMap, product);
                        if (findProduct && activity.productRelation === ProductRelationEnum.Included) {
                            canJoinProducts.push(product);
                        }
                        else if (!findProduct && activity.productRelation === ProductRelationEnum.Excluded) {
                            canJoinProducts.push(product);
                        }
                    }
                });
            }
            else {
                each(ladderItems, (ladderItem) => {
                    if (!alearedJoinItemPks.includes((ladderItem === null || ladderItem === void 0 ? void 0 : ladderItem.pk) || '')) {
                        canJoinProducts.push(ladderItem);
                    }
                });
            }
            const miniLen = ((_c = find((_b = activity.extra) === null || _b === void 0 ? void 0 : _b.ladderDiscount, (activity) => {
                if (activity.discountType === DiscountTypeEnum.DiscountRate) {
                    return activity.enable && toNumber(activity.discountValue) !== 1;
                }
                else if (activity.discountType === DiscountTypeEnum.DiscountFee) {
                    return activity.enable && toNumber(activity.discountValue) > 0;
                }
                return activity.enable;
            })) === null || _c === void 0 ? void 0 : _c.index) || Infinity;
            let nowProductCnt = 0;
            // 能参加的餐品必须有才行
            if (canJoinProducts.length > 0 && sumBy(canJoinProducts, 'cnt') >= miniLen) {
                const activityJoinPks = [];
                let ladderDiscountLen = ((_d = activity.extra) === null || _d === void 0 ? void 0 : _d.ladderDiscount.length) || 0; // 阶梯数量
                if (activity.isIncludeModifier) {
                    canJoinProducts = orderBy(canJoinProducts, ['productAndModifierPrice'], 'desc');
                }
                else {
                    canJoinProducts = orderBy(canJoinProducts, ['price'], 'desc');
                }
                if ((_e = activity.extra) === null || _e === void 0 ? void 0 : _e.lowPriceFirst) {
                    const oneCntProducts = [];
                    let allCnt = 0;
                    // 先拆
                    each(canJoinProducts, (product) => {
                        var _a;
                        for (let i = 0; i < ((_a = product.cnt) !== null && _a !== void 0 ? _a : 1); i++) {
                            oneCntProducts.push(Object.assign(Object.assign({}, product), { cnt: 1 }));
                            allCnt++;
                        }
                    });
                    if (oneCntProducts.length > ladderDiscountLen) {
                        let removeIdx = 0;
                        if (activity.extra.isCloseOfferCycle) {
                            removeIdx = oneCntProducts.length - ladderDiscountLen;
                        }
                        else {
                            removeIdx = oneCntProducts.length % ladderDiscountLen;
                        }
                        if (removeIdx > 0) {
                            remove(oneCntProducts, (v, idx) => idx < removeIdx);
                        }
                    }
                    // 在合并
                    const mergeOneProductMap = {};
                    each(oneCntProducts, (oneCntProduct) => {
                        const pk = oneCntProduct.pk || oneCntProduct.productNo + '_' + oneCntProduct.scaleNo;
                        if (!mergeOneProductMap[pk]) {
                            mergeOneProductMap[pk] = oneCntProduct;
                        }
                        else {
                            mergeOneProductMap[pk].cnt = (mergeOneProductMap[pk].cnt || 1) + 1;
                        }
                    });
                    canJoinProducts = values(mergeOneProductMap);
                    if (!isCloseOfferCycle) {
                        isCloseOfferCycle = true;
                        const cycleCnt = Math.floor(allCnt / ladderDiscountLen);
                        if (cycleCnt >= 1) {
                            const newLadderDiscount = [];
                            let j = 1;
                            for (const ladderDiscount of (_f = activity.extra) === null || _f === void 0 ? void 0 : _f.ladderDiscount) {
                                for (let i = 0; i < cycleCnt; i++) {
                                    newLadderDiscount.push(Object.assign(Object.assign({}, ladderDiscount), { index: j }));
                                    j++;
                                }
                            }
                            activity.extra.ladderDiscount = newLadderDiscount;
                            ladderDiscountLen = newLadderDiscount.length;
                        }
                    }
                }
                if ((_g = activity.extra) === null || _g === void 0 ? void 0 : _g.isOverlySingleItemDiscount) {
                    // 是否关闭循环优惠
                    // 能叠加
                    each(canJoinProducts, (product) => {
                        var _a, _b;
                        const pk = product.pk || product.productNo + '_' + product.scaleNo;
                        if (!joinPks.includes(pk)) {
                            const offMap = {};
                            const originProductPrice = activity.isIncludeModifier ? product.productAndModifierPrice : product.price;
                            if (itemMap[pk]) {
                                let offIdx = 0;
                                each(itemMap[pk].items, (item) => {
                                    var _a, _b;
                                    const avgOff = item.off / ((_a = item.cnt) !== null && _a !== void 0 ? _a : 1);
                                    if (avgOff > 0) {
                                        for (let i = 0; i < ((_b = item.cnt) !== null && _b !== void 0 ? _b : 1); i++) {
                                            offMap[offIdx] = avgOff;
                                            offIdx++;
                                        }
                                    }
                                });
                            }
                            for (let i = 0; i < ((_a = product.cnt) !== null && _a !== void 0 ? _a : 1); i++) {
                                // 取整数
                                const ladderDiscountFloor = floor(nowProductCnt / ladderDiscountLen);
                                if (isCloseOfferCycle && nowProductCnt >= ladderDiscountLen && ladderDiscountFloor > 0) {
                                    nowProductCnt++;
                                    continue;
                                }
                                // 取余数
                                const ladderDiscountIndex = nowProductCnt % ladderDiscountLen;
                                const ladder = (_b = activity.extra) === null || _b === void 0 ? void 0 : _b.ladderDiscount[ladderDiscountIndex];
                                let ladderOff = 0; // 优惠金额
                                if (ladder === null || ladder === void 0 ? void 0 : ladder.enable) {
                                    const productPrice = originProductPrice - (offMap[i] || 0);
                                    if (productPrice > 0) {
                                        if ((ladder === null || ladder === void 0 ? void 0 : ladder.discountType) === DiscountTypeEnum.DiscountFee) {
                                            ladderOff = toNumber(ladder.discountValue);
                                        }
                                        else if ((ladder === null || ladder === void 0 ? void 0 : ladder.discountType) === DiscountTypeEnum.DiscountRate) {
                                            ladderOff = toFixed(productPrice * (1 - ladder.discountValue));
                                        }
                                        if (ladderOff > productPrice) {
                                            ladderOff = productPrice;
                                        }
                                        ladderDiscountAllOff += ladderOff;
                                    }
                                }
                                pushToItemMap({
                                    activity,
                                    product,
                                    ladderOff,
                                    itemMap,
                                    pk,
                                    memberCouponMap,
                                    effectLadderCouponIds,
                                    alearedJoinItemPks,
                                    memberItemCouponMap,
                                });
                                nowProductCnt++;
                            }
                            activityJoinPks.push(pk);
                        }
                    });
                }
                else {
                    // 不能叠加
                    if (((_h = activity.extra) === null || _h === void 0 ? void 0 : _h.discountWithSingleItemFirst) === 'activity') {
                        let joinCnt = sumBy(canJoinProducts, 'cnt');
                        // 本活动优先
                        each(canJoinProducts, (product) => {
                            var _a, _b;
                            const pk = product.pk || product.productNo + '_' + product.scaleNo;
                            // 餐品需要没有参加阶梯活动
                            if (!joinPks.includes(pk)) {
                                let productPrice = product.price;
                                if (activity.isIncludeModifier) {
                                    productPrice = product.productAndModifierPrice;
                                }
                                const item = itemMap[pk];
                                if (fullItemNFreeMap[pk]) {
                                    delete fullItemNFreeMap[pk];
                                }
                                if (item) {
                                    const removePkIndexMap = {};
                                    each(item.items, (itemV, idx) => {
                                        if ((!isSelectItemCoupon &&
                                            !isSelectLadderCoupon &&
                                            activity.memberCouponId &&
                                            itemV.offType !== OffTypeEnum.Plan &&
                                            !itemV.isFullItemNFree) ||
                                            (!isSelectItemCoupon &&
                                                !isSelectLadderCoupon &&
                                                !activity.memberCouponId &&
                                                itemV.offType === OffTypeEnum.Coupon) ||
                                            (!isSelectItemCoupon &&
                                                isSelectLadderCoupon &&
                                                selectCouponIds.includes(activity.memberCouponId) &&
                                                activity.memberCouponId &&
                                                itemV.offType !== OffTypeEnum.Plan &&
                                                !itemV.isFullItemNFree) ||
                                            (!activity.memberCouponId &&
                                                itemV.offType !== OffTypeEnum.Coupon &&
                                                itemV.offType !== OffTypeEnum.Plan &&
                                                !itemV.isFullItemNFree)) {
                                            if (removePkIndexMap[pk]) {
                                                removePkIndexMap[pk].push(idx);
                                            }
                                            else {
                                                removePkIndexMap[pk] = [idx];
                                            }
                                        }
                                        else {
                                            joinCnt = joinCnt - (itemV.cnt || 1);
                                        }
                                    });
                                    if (joinCnt >= miniLen) {
                                        each(removePkIndexMap, (idx, pk) => {
                                            productAllOff -= itemMap[pk].itemAllOff;
                                            remove(itemMap[pk].items, (item, index) => {
                                                if (idx.includes(index)) {
                                                    if (item.offType === OffTypeEnum.Coupon) {
                                                        const pk = item.pk || '';
                                                        const memberCouponId = item.offId || 0;
                                                        const memberCoupon = memberCouponMap[memberCouponId] || memberItemCouponMap[memberCouponId];
                                                        if (memberCoupon) {
                                                            memberCoupon.status = StatusEnum.Disable;
                                                            memberCoupon.isSelect = false;
                                                            memberCoupon.useItem = null;
                                                            if (memberCoupon.canUseProductPk && memberCoupon.canUseProductPk.indexOf(pk) > -1) {
                                                                memberCoupon.canUseProductPk.splice(memberCoupon.canUseProductPk.indexOf(pk), 1);
                                                            }
                                                        }
                                                    }
                                                    itemMap[pk].itemAllOff -= item.off;
                                                    return true;
                                                }
                                                return false;
                                            });
                                        });
                                    }
                                }
                                if (joinCnt >= miniLen) {
                                    for (let i = 0; i < ((_a = product.cnt) !== null && _a !== void 0 ? _a : 1); i++) {
                                        // 取整数
                                        const ladderDiscountFloor = floor(nowProductCnt / ladderDiscountLen);
                                        if (isCloseOfferCycle && nowProductCnt >= ladderDiscountLen && ladderDiscountFloor > 0) {
                                            nowProductCnt++;
                                            continue;
                                        }
                                        // 取余数
                                        const ladderDiscountIndex = nowProductCnt % ladderDiscountLen;
                                        const ladder = (_b = activity.extra) === null || _b === void 0 ? void 0 : _b.ladderDiscount[ladderDiscountIndex];
                                        let ladderOff = 0; // 优惠金额
                                        if (ladder === null || ladder === void 0 ? void 0 : ladder.enable) {
                                            if ((ladder === null || ladder === void 0 ? void 0 : ladder.discountType) === DiscountTypeEnum.DiscountFee) {
                                                ladderOff = toNumber(ladder.discountValue);
                                            }
                                            else if ((ladder === null || ladder === void 0 ? void 0 : ladder.discountType) === DiscountTypeEnum.DiscountRate) {
                                                ladderOff = toFixed(productPrice * (1 - ladder.discountValue));
                                            }
                                            if (ladderOff > productPrice) {
                                                ladderOff = productPrice;
                                            }
                                            ladderDiscountAllOff += ladderOff;
                                        }
                                        pushToItemMap({
                                            activity,
                                            product,
                                            ladderOff,
                                            itemMap,
                                            pk,
                                            memberCouponMap,
                                            effectLadderCouponIds,
                                            alearedJoinItemPks,
                                            memberItemCouponMap,
                                        });
                                        nowProductCnt++;
                                    }
                                    activityJoinPks.push(pk);
                                }
                            }
                        });
                    }
                    else {
                        // 其他单品折扣优先
                        each(canJoinProducts, (product) => {
                            var _a;
                            const pk = product.pk || product.productNo + '_' + product.scaleNo;
                            let productPrice = product.price;
                            if (activity.isIncludeModifier) {
                                productPrice = product.productAndModifierPrice;
                            }
                            // 餐品需要没有参加指定活动
                            if (!joinPks.includes(pk) && !fullItemNFreeMap[pk]) {
                                const item = itemMap[pk];
                                const joinOtherCnt = sumBy(item === null || item === void 0 ? void 0 : item.items, 'cnt') || 0;
                                const productCnt = product.cnt || 1;
                                if (joinOtherCnt < productCnt) {
                                    const joinCnt = productCnt - joinOtherCnt;
                                    for (let i = 0; i < (joinCnt !== null && joinCnt !== void 0 ? joinCnt : 1); i++) {
                                        // 取整数
                                        const ladderDiscountFloor = floor(nowProductCnt / ladderDiscountLen);
                                        if (isCloseOfferCycle && nowProductCnt >= ladderDiscountLen && ladderDiscountFloor > 0) {
                                            nowProductCnt++;
                                            continue;
                                        }
                                        // 取余数
                                        const ladderDiscountIndex = nowProductCnt % ladderDiscountLen;
                                        const ladder = (_a = activity.extra) === null || _a === void 0 ? void 0 : _a.ladderDiscount[ladderDiscountIndex];
                                        let ladderOff = 0; // 优惠金额
                                        if (ladder === null || ladder === void 0 ? void 0 : ladder.enable) {
                                            if ((ladder === null || ladder === void 0 ? void 0 : ladder.discountType) === DiscountTypeEnum.DiscountFee) {
                                                ladderOff = toNumber(ladder.discountValue);
                                            }
                                            else if ((ladder === null || ladder === void 0 ? void 0 : ladder.discountType) === DiscountTypeEnum.DiscountRate) {
                                                ladderOff = toFixed(productPrice * (1 - ladder.discountValue));
                                            }
                                            if (ladderOff > productPrice) {
                                                ladderOff = productPrice;
                                            }
                                            ladderDiscountAllOff += ladderOff;
                                        }
                                        pushToItemMap({
                                            activity,
                                            product,
                                            ladderOff,
                                            itemMap,
                                            pk,
                                            memberCouponMap,
                                            effectLadderCouponIds,
                                            alearedJoinItemPks,
                                            memberItemCouponMap,
                                        });
                                        nowProductCnt++;
                                    }
                                    activityJoinPks.push(pk);
                                }
                            }
                        });
                    }
                }
                joinPks.push(...activityJoinPks);
                if (activity.promoCode) {
                    if (usePromoCodeStatus === UsePromoCodeStatusEnum.Ineffective) {
                        usePromoCodeStatus = UsePromoCodeStatusEnum.Effective;
                    }
                    enablePromoCodeActivity.push(activity.activityId);
                }
                if (activity.couponId) {
                    if (nowProductCnt < miniLen && !effectLadderCouponIds.includes(activity.memberCouponId)) {
                        //指定满减优惠
                        const memberCouponId = activity.memberCouponId;
                        memberCouponMap[memberCouponId].isSelect = false;
                        memberCouponMap[memberCouponId].status = StatusEnum.Disable;
                        memberCouponMap[memberCouponId].canUse = false;
                    }
                }
            }
            else {
                if (activity.couponId) {
                    //指定满减优惠
                    const memberCouponId = activity.memberCouponId;
                    memberCouponMap[memberCouponId].isSelect = false;
                    memberCouponMap[memberCouponId].status = StatusEnum.Disable;
                    memberCouponMap[memberCouponId].canUse = false;
                }
            }
        });
    }
    if (disbaleLadderCouponIds.length > 0 && ladderCoupons.length > 0) {
        each(ladderCoupons, (ladderCoupon) => {
            if (disbaleLadderCouponIds.includes(ladderCoupon.memberCouponId) &&
                (ladderCoupon.status === StatusEnum.Enable || ladderCoupon.status === StatusEnum.Mutex)) {
                ladderCoupon.status = StatusEnum.Disable;
                ladderCoupon.isSelect = false;
                ladderCoupon.canUse = false;
            }
        });
    }
    if (ladderDiscountAllOff <= 0 && effectLadderCouponIds.length > 0) {
        each(effectLadderCouponIds, (couponId) => {
            memberCouponMap[couponId].isSelect = false;
            memberCouponMap[couponId].canUse = false;
            memberCouponMap[couponId].status = StatusEnum.Mutex;
        });
        effectLadderCouponIds.length = 0;
    }
    return { productAllOff, ladderDiscountAllOff, usePromoCodeStatus, effectLadderCouponIds };
}
/**
 * ItemMap 处理
 * @param pushOpt
 */
function pushToItemMap(pushOpt) {
    var _a, _b, _c;
    const { itemMap, pk, activity, ladderOff, product, memberCouponMap, effectLadderCouponIds, alearedJoinItemPks, memberItemCouponMap, } = pushOpt;
    if (!itemMap[pk]) {
        itemMap[pk] = {
            items: [],
            itemAllOff: 0,
        };
    }
    if (activity.memberCouponId) {
        memberCouponMap[activity.memberCouponId].isSelect = true;
        memberCouponMap[activity.memberCouponId].status = StatusEnum.Enable;
        memberCouponMap[activity.memberCouponId].canUse = true;
        effectLadderCouponIds.push(activity.memberCouponId);
    }
    alearedJoinItemPks.push(pk);
    itemMap[pk].itemAllOff += ladderOff;
    itemMap[pk].items.push(Object.assign(Object.assign({}, product), { cnt: 1, off: ladderOff, activity: activity, offId: activity.activityId || activity.memberCouponId, offTip: activity.activityName || activity.couponName, offType: activity.memberCouponId ? OffTypeEnum.Coupon : OffTypeEnum.LadderDiscount, couponType: (activity.memberCouponId && CouponTypeEnum.Ladder), isIncludeModifier: (_a = activity.isIncludeModifier) !== null && _a !== void 0 ? _a : false }));
    // 不能叠加，本活动优先
    if (!((_b = activity.extra) === null || _b === void 0 ? void 0 : _b.isOverlySingleItemDiscount) && ((_c = activity.extra) === null || _c === void 0 ? void 0 : _c.discountWithSingleItemFirst) === 'activity') {
        each(memberItemCouponMap, (memberItemCoupon) => {
            var _a;
            if (memberItemCoupon.canUseProductPk && memberItemCoupon.canUseProductPk.indexOf(pk) > -1) {
                memberItemCoupon.canUseProductPk.splice(memberItemCoupon.canUseProductPk.indexOf(pk), 1);
                if (((_a = memberItemCoupon.canUseProductPk) === null || _a === void 0 ? void 0 : _a.length) <= 0) {
                    memberItemCoupon.status = StatusEnum.Disable;
                }
            }
        });
    }
}
//# sourceMappingURL=calLadderDiscount.js.map